import { createAction } from 'redux-actions'

export const SET_FORMS_AND_DEPENDENCIES = createAction('SET_FORMS_AND_DEPENDENCIES')
export const FORM_ADD_QUESTIONS_VALUE = createAction('FORM_ADD_QUESTIONS_VALUE')
export const FORM_SET_QUESTIONS_VALUE = createAction('FORM_SET_QUESTIONS_VALUE')
export const FORM_SELECT_POINT = createAction('FORM_SELECT_POINT')
export const FORM_SELECT_POINT_START = createAction('FORM_SELECT_POINT_START')
export const FORM_SELECT_POINT_SUCCEEDED = createAction('FORM_SELECT_POINT_SUCCEEDED')
export const FORM_SELECT_POINT_ERROR = createAction('FORM_SELECT_POINT_ERROR')
export const FORM_SELECT_FORM = createAction('FORM_SELECT_FORM')
export const FORM_SET_STEP = createAction('FORM_SET_STEP')
export const FORM_CLEAN_FORM = createAction('FORM_CLEAN_FORM')

/**
 * FORM START
 */

export const FORM_SET_STAGE = createAction('FORM_SET_STAGE')
export const FORM_SET_STAGE_START = createAction('FORM_SET_STAGE_START')
export const FORM_SET_STAGE_SUCCEEDED = createAction('FORM_SET_STAGE_SUCCEEDED')
export const FORM_SET_STAGE_ERROR = createAction('FORM_SET_STAGE_ERROR')
export const FORM_SET_STAGE_FINALLY = createAction('FORM_SET_STAGE_FINALLY')
export const FINALIZE_FORM = createAction('FINALIZE_FORM')
export const FINALIZE_FORM_START = createAction('FINALIZE_FORM_START')
export const FINALIZE_FORM_SUCCEEDED = createAction('FINALIZE_FORM_SUCCEEDED')
export const FINALIZE_FORM_ERROR = createAction('FINALIZE_FORM_ERROR')
export const FINALIZE_FORM_FINALLY = createAction('FINALIZE_FORM_FINALLY')
export const FORM_SET_START_FORM = createAction('FORM_SET_START_FORM')

/**
 * FORM DETAIL
 */

export const FORM_DETAIL = createAction('FORM_DETAIL')
export const FORM_DETAIL_START = createAction('FORM_DETAIL_START')
export const FORM_DETAIL_SUCCEEDED = createAction('FORM_DETAIL_SUCCEEDED')
export const FORM_DETAIL_ERROR = createAction('FORM_DETAIL_ERROR')
export const FORM_DETAIL_FINALLY = createAction('FORM_DETAIL_FINALLY')

/**
 * PENDING FORMS
 */

export const FORM_SET_PENDING_FORM = createAction('FORM_SET_PENDING_FORM')
export const FORM_SET_PENDING_SUCCEEDED = createAction('FORM_SET_PENDING_SUCCEEDED')

